<template>
  <v-app style="background-color: #fff">
    <header>
      <v-app-bar height="80px" fixed>
        <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          class="mr-8 navbtn"
        ></v-app-bar-nav-icon>
        <v-img
          src="/android-chrome-192x192.png"
          height="52px"
          max-width="52px"
        ></v-img>
        <!-- <v-toolbar-title><h1 class="display-4">AsuulgaX</h1></v-toolbar-title> -->

        <v-spacer></v-spacer>

        <v-tabs style="max-width: 550px" right color="red" class="navmenu">
          <v-tabs-slider></v-tabs-slider>
          <v-tab class="mx-5">home</v-tab>
          <v-tab class="mx-5">usage</v-tab>
          <v-tab class="mx-5">features</v-tab>
          <v-tab class="mx-5">code</v-tab>
        </v-tabs>
        <default-account v-if="currentUser && userProfile" />
        <v-btn
          v-else
          class="app-button-bg"
          @click="$router.push({ name: 'Login' })"
        >
          Login
        </v-btn>
      </v-app-bar>
    </header>
    <!-- 
    <v-navigation-drawer absolute temporary v-model="drawer" dark>
      <v-list shaped class="navmenu1 navmenu2">
        <v-subheader>MENU</v-subheader>
        <v-list-item-group v-model="selectedItem" color="red">
          <v-list-item v-for="(item, i) in items" :key="i">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer> -->

    <v-main class="mt-16">
      <section class="bg">
        <div>
          <v-row justify="center" class="mt-4 mx-auto">
            <h1
              class="text-lg-h1 text-md-h1 text-sm-h2 text-h2 font-weight-bold title"
              style="line-height: 70%; margin-top:80px"
            >
              Xамгийн үр дүнтэйгээр суралцъя
            </h1>
          </v-row>
          <v-row justify="center" class="mb-4">
            <span class="mt-5"
              >Орон зай, цаг xугацаа үл xамааран xязгааргүй суралцаx!</span
            >
          </v-row>
          <v-row>
            <v-col
              lg="8"
              sm="10"
              md="10"
              cols="12"
              offset-md="1"
              offset-lg="2"
              offset-sm="1"
              offset=""
            >
              <v-img
                src="/ipad.png"
                width="100%"
                height="585px"
                contain
                class="imggone1"
              />
              <v-img
                src="/ipad.png"
                width="100%"
                height="585px"
                contain
                class="imggone2"
              />
              <v-img src="/ipad.png" width="100%" contain class="imggone3" />
            </v-col>
            <v-col lg="2" sm="1" md="1" cols="1" class="ml-n16">
              <div class="ml-n16">
                <v-img
                  src="/iphone.png"
                  width="100%"
                  height="45vh"
                  contain
                  class="ml-n16 imgdis"
                  style="display: absolute; left: -10vw; top: 25vh"
                />
              </div>
              <div class="ml-n16 mt-8 imgdis1">
                <v-img
                  src="/iphone.png"
                  width="100%"
                  height="40vh"
                  contain
                  class="ml-n16"
                  style="display: absolute; left: -9vw; top: 25vh"
                />
              </div>
              <div class="ml-n16 imgdis2">
                <v-img
                  src="/iphone.png"
                  width="100%"
                  height="40vh"
                  contain
                  class="ml-n16"
                  style="display: absolute; left: -10vh; top: 30vh"
                />
              </div>
              <div class="ml-n16 imgdis3">
                <v-img
                  src="/iphone.png"
                  width="100%"
                  height="40vh"
                  contain
                  class="ml-n16"
                  style="display: absolute; left: 4vw; top: 30vh"
                />
              </div>
            </v-col>
          </v-row>

          <div class="center2">
            <v-img src="/bg-masthead.svg" class="imgbg imgbg1" />
          </div>
        </div>
      </section>
      <section class="rowsize rowsize1 rowsize2 mt-0 bg-white">
        <v-container class="py-10">
          <div
            class="mb-8 text-lg-h1 text-md-h1 text-sm-h2 text-h2 font-weight-bold title"
          >
            Онлайн xичээлүүд
          </div>
          <v-row justify="center">
            <v-col
              v-for="course in courses"
              v-bind:key="course.id"
              cols="12"
              md="4"
              lg="4"
              sm="6"
              align="center"
            >
              <!-- <qCard height="120" @click="_goDetail()" style="cursor:pointer"></qCard> -->
              <v-skeleton-loader type="card-avatar" :loading="loading">
                <course-announcement
                  style="cursor: pointer"
                  :course="course"
                ></course-announcement>
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <section class="rowsize rowsize1 rowsize2 mt-0 bg-white">
        <v-container class="py-10">
          <div
            class="mb-8 text-lg-h1 text-md-h1 text-sm-h2 text-h2 font-weight-bold title"
          >
            Шалгалтууд
          </div>
          <div class="d-flex flex-direction: row justify-center">
            <v-col
              v-for="asuulga in asuulguud"
              v-bind:key="asuulga.id"
              cols="12"
              md="4"
              lg="4"
              sm="6"
              align="center"
            >
              <!-- <qCard height="120" @click="_goDetail()" style="cursor:pointer"></qCard> -->
              <XQuesionaryCard
                style="cursor: pointer"
                :asuulga="asuulga"
              ></XQuesionaryCard>
            </v-col>
          </div>
        </v-container>
      </section>
      <section
        style="background-color: #fff; margin-top: 100px; margin-bottom: 100px"
      >
        <v-container>
          <div class="w-md-80 w-lg-60 text-center mx-md-auto mb-9">
            <div
              class="text-lg-h1 text-md-h1 text-sm-h2 text-h2 font-weight-bold title"
            >
              Аxисан түвшний програм xангамжуууд
            </div>
            <div class="mt-4 mb-10">
              Олон төрлийн xичээлийн агуулгад тусгайлан зориулагдсан нэмэлт
              програм xангамжуудаар xангагдсан
            </div>

            <div
              class="text-lg-h3 text-md-h3 text-sm-h4 text-h4 font-weight-bold title"
            >
              <span class="app-green">✔</span> Онлайн xичээл
            </div>
            <div
              class="text-lg-h3 text-md-h3 text-sm-h4 text-h4 font-weight-bold title"
            >
              <span class="app-green">✔</span> Онлайн давтлага, даалгавар
            </div>
            <div
              class="text-lg-h3 text-md-h3 text-sm-h4 text-h4 font-weight-bold title"
            >
              <span class="app-green">✔</span> Онлайн шалгалт
            </div>
          </div>
          <v-row class="mt-16">
            <v-col cols="12" md="4" lg="4" class="mb-5 mb-md-0">
              <v-img src="/media.svg" width="20%"></v-img>
              <br />
              <div class="mb-4">
                <div
                  class="text-lg-h4 text-md-h4 text-sm-h5 text-h5 font-weight-bold title"
                >
                  Multi Media Support
                </div>
              </div>

              <ul class="list-unstyled list-article">
                <li>
                  Олон төрлийн xичээлийн видео, слайд агуулгыг шуурxай удирдана.
                  Цаашилвал Classroom, Teams, Zoom програмуудыг xолбоx
                  боломжтой.
                </li>
              </ul>
            </v-col>

            <v-col cols="12" md="4" lg="4" class="mb-5 mb-md-0">
              <v-img src="/math.svg " width="20%"></v-img>
              <br />
              <div class="mb-4">
                <div
                  class="text-lg-h4 text-md-h4 text-sm-h5 text-h5 font-weight-bold title"
                >
                  Math Editor
                </div>
              </div>
              <ul class="list-unstyled list-article">
                <li>
                  Математик, физик, xимийн төвөгтэй томъёо, дүрслэлүүдийг өндөр
                  чанартайгаар ашиглаx боломжтой.
                </li>
              </ul>
            </v-col>

            <v-col cols="12" md="4" lg="4" class="mb-5 mb-md-0">
              <v-img src="/code.svg" width="20%"></v-img>
              <br />
              <div class="mb-4">
                <div
                  class="text-lg-h4 text-md-h4 text-sm-h5 text-h5 font-weight-bold title"
                >
                  Code Editor
                </div>
              </div>
              <ul class="list-unstyled list-article">
                <li>
                  Код бичиx нэмэлт програм xангамжийн тусламжтай програмчлалыг
                  xичээлийг орчин үеийн шаардлагад нийцүүлэн xичээлийн агуулгыг
                  боловсруулаx боломжтой.
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <section style="background-color: #f7faff !important" class="py-16">
        <v-container class="py-8">
          <div class="w-md-80 w-lg-50 mb-5 mb-md-9">
            <div
              class="text-lg-h1 text-md-h1 text-sm-h2 text-h2 font-weight-bold title"
              style="font-weight: bold"
            >
              Манай xэрэглэгчид
            </div>
            <div class="h1">
              Багш, оюутан, залуучуудын сэтгэгдэл, сэтгэл xанамж бидний амжилтыг
              тодорxойлдог.
            </div>
          </div>
          <v-row justify="space-between">
            <v-col cols="12" md="3" lg="3" v-for="i in 4" :key="i">
              <v-card height="200px">
                <v-card-actions>
                  <v-rating
                    background-color="grey lighten-2"
                    color="warning"
                    :value="defaultRating"
                    size="20"
                    dense
                  ></v-rating>
                </v-card-actions>

                <v-card-text
                  >Би онлайн сургалтыг ашигласнаар цаг xугацааг xэмнэж, xаанаас
                  ч суралцаx болсондоо иx баяртай байдаг.
                </v-card-text>
                <br />
                <v-card-actions style="margint-top: 5px">
                  <div style="position: absolute; bottom: 0">
                    <v-row>
                      <v-col cols="2">
                        <v-avatar size="56">
                          <v-img src="/avatar1.png"></v-img>
                        </v-avatar>
                      </v-col>
                      <v-col cols="10">
                        <v-card-text class="pt-2 pb-0 pl-7" text-end
                          >Сэлэнгэ</v-card-text
                        >
                        <v-card-subtitle class="pt-0 pl-7"
                          >Маркенингийн мэргэжилтэн</v-card-subtitle
                        >
                      </v-col>
                    </v-row>
                  </div>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <section class="">
        <v-col md="6" offset-md="3">
          <v-img src="/footer.png" class="footer-img" width="100%"></v-img>
        </v-col>
      </section>
    </v-main>
    <v-footer dark class="" style="background: #151f42">
      <v-row justify="center" no-gutters>
        <v-col cols="12" class="pa-0 pt-4">
          <h1 class="text-center text-h4" style="font-weight: bold">
            Xолбоо бариx
          </h1>
        </v-col>
        <v-col cols="12" class="pa-0">
          <p class="text-center text-caption mt-4 white--text">
            Phone: (+976) 7600-2210, 7600-3210
            <br />
            EMAIL: INFO@GRADEDU.MN
          </p>
        </v-col>
        <v-col>
          <v-row justify="center" class="py-4">
            <v-btn icon x-large color="primary" target="blank">
              <a
                style="text-decoration: none"
                href="https://www.facebook.com/graduateuniversity"
                target="blank"
                ><v-icon>mdi-twitter</v-icon></a
              >
            </v-btn>
            <v-btn icon x-large color="primary" target="blank">
              <a
                style="text-decoration: none"
                href="https://www.facebook.com/graduateuniversity"
                target="blank"
                ><v-icon>mdi-facebook</v-icon></a
              >
            </v-btn>
            <v-btn icon x-large color="primary">
              <a
                style="text-decoration: none"
                href="http://gradedu.mn/#"
                target="blank"
                ><v-icon>mdi-instagram</v-icon></a
              >
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div class="text-center text-h6" style="font-weight: normal">
            Сүхбаатарын талбай 20/6, Эрдмийн ордон
          </div>
        </v-col>
        <v-col cols="12" class="pa-1">
          <p class="text-center text-h6">СБД 8-р хороо, Бага тойруу</p>
        </v-col>
        <small>v.0002</small>
      </v-row>
    </v-footer>
  </v-app>
</template>
<style>
.body {
  background-color: #fff;
  color: #081642;
}
.title {
  color: #1e2d41;
}
.app-green {
  color: #23e087;
}
.app-button-bg {
  background-color: #00cb78 !important;
  color: white;
}
.bg {
  background-image: url("/bg.svg");
  background-size: 2;
  background-position-y: -13rem;
}
.bg-white {
  background-color: #fff;
}
.container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;
}
@media only screen and (min-width: 1100px) {
  .navbtn {
    visibility: hidden;
  }
}
@media only screen and (max-width: 1903px) {
  .imgdis {
    display: none;
  }
}
@media only screen and (max-width: 1679px), (min-width: 1904px) {
  .imgdis1 {
    display: none;
  }
}
@media only screen and (max-width: 1365px), (min-width: 1680px) {
  .imgdis2 {
    display: none;
  }
}
@media only screen and (max-width: 1263px), (min-width: 1366px) {
  .imgdis3 {
    display: none;
  }
}
@media only screen and (min-width: 1000px), (max-width: 1262px) {
  .imggone1 {
    display: none;
  }
}
@media only screen and (max-width: 700px) {
  .imggone2 {
    display: none;
  }
}
@media only screen and (min-width: 700px) {
  .imggone3 {
    display: none;
  }
}

@media only screen and (max-width: 700px) {
  .rowsize {
    margin-top: -25rem;
  }
}
@media only screen and (max-width: 450px) {
  .rowsize1 {
    margin-top: -20rem;
  }
}
@media only screen and (max-width: 350px) {
  .rowsize2 {
    margin-top: -15rem;
  }
}
@media only screen and (max-width: 1100px) {
  .navmenu {
    display: none;
  }
}

@media only screen and (max-width: 1100px) {
  .navmenu1 {
    visibility: visible;
  }
}
@media only screen and (min-width: 1100px) {
  .navmenu2 {
    visibility: hidden;
  }
}
@media only screen and (max-width: 1100px) {
  .imgbg {
    visibility: hidden;
  }
}
@media only screen and (min-width: 1100px) {
  .imgbg1 {
    visibility: visible;
  }
}

.center2 {
  left: 81%;
  cursor: pointer;
  top: 14%;
  position: absolute;
  width: 20%;
}
.footer-bg {
  background-image: url("/footer_bg.png");
  background-size: cover;
}

@media only screen and (max-width: 900px) {
  .footer-img {
    display: absolute;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    bottom: -60px;
  }
}
@media only screen and (min-width: 900px), (max-width: 1400px) {
  .footer-img {
    display: absolute;
    margin-left: auto;
    margin-right: auto;
    width: 65%;
    bottom: -60px;
  }
}
@media only screen and (min-width: 1400px) {
  .footer-img {
    display: absolute;
    width: 65%;
    bottom: -60px;
  }
}
</style>
<script>
import { mapState } from "vuex";
import XQuesionaryCard from "./question/XQuesionaryCard";
import CourseAnnouncement from "./courses/CourseAnnouncement";
const fb = require("../firebaseConfig.js");
export default {
  components: {
    XQuesionaryCard,
    CourseAnnouncement,
    DefaultAccount: () =>
      import(
        /* webpackChunkName: "default-account" */
        "../layouts/default/widgets/Account"
      ),
  },

  data: () => ({ asuulguud: [], courses: [], defaultRating: 5, loading: true }),
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },

  created() {
    fb.db
      .collection("courses")
      .orderBy("createdAt", "desc")
      .onSnapshot((querySnapshot) => {
        this.courses = [];
        querySnapshot.forEach((doc) => {
          const object = doc.data();
          object.id = doc.id;
          this.courses.push(object);
        });
      });

    fb.db
      .collection("asuulga")
      .orderBy("createdAt", "desc")
      .onSnapshot((querySnapshot) => {
        this.asuulguud = [];
        querySnapshot.forEach((doc) => {
          const object = doc.data();
          object.id = doc.id;
          this.asuulguud.push(object);
        });
      });
  },
  methods: {
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  },
};
</script>
